
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment assurer la mise en ligne d’un site Web ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article s’intéresse à une étape cruciale dans la réalisation d’un site Web. Il vous explique comment assurer une mise en ligne dans les meilleures conditions.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment assurer la mise en ligne d’un site Web ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article s’intéresse à une étape cruciale dans la réalisation d’un site Web. Il vous explique comment assurer une mise en ligne dans les meilleures conditions.",
        },
      ],
    };
  },
};
